var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Twitter"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    clipPath: "url(#clip-Twitter)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10835",
    "data-name": "Group 10835",
    transform: "translate(1 1.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    transform: "translate(0 -0.411)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: "0 0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Twitter-2",
    "data-name": "Twitter",
    d: "M239.155,864.168a4.364,4.364,0,0,1-1.235.339,2.149,2.149,0,0,0,.944-1.191,4.283,4.283,0,0,1-1.365.522,2.151,2.151,0,0,0-3.718,1.471,2.253,2.253,0,0,0,.055.491,6.115,6.115,0,0,1-4.434-2.234,2.151,2.151,0,0,0,.66,2.862,2.152,2.152,0,0,1-.975-.269v.029a2.151,2.151,0,0,0,1.726,2.107,2.191,2.191,0,0,1-.971.037,2.149,2.149,0,0,0,2.008,1.493,4.315,4.315,0,0,1-2.668.916,4.379,4.379,0,0,1-.513-.031,6.119,6.119,0,0,0,9.42-5.149v-.28A4.362,4.362,0,0,0,239.155,864.168Z",
    transform: "translate(-223.186 -856.546)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.bf8c6458cf3a9fad13017a9a996de46f.svg";
export { ForwardRef as ReactComponent };